var $ = require( "jquery" )

$(document).ready( function(){
  $('.location-type-selection-field').change(function(){
    var selected_location_type_id = parseInt( $(this).find(":selected").val() );
    updateDisplayForSelectedLocationType( selected_location_type_id );
  });

  var selected_location_type_id = parseInt( $('.location-type-selection-field').find(":selected").val() );
  updateDisplayForSelectedLocationType( selected_location_type_id );
});

$(document).ready( function(){
  $('input[name="location[can_support_gg_makeover]"').change( function(){
    if( $(this).val() == '0' ){
      var contact_info_phone = $('#contact_info_phone').val();
      alert('Please call GG National at ' + contact_info_phone + '.');
    }
  });
});

function updateDisplayForSelectedLocationType( selected_location_type_id ){
  if( !isNaN( selected_location_type_id ) ){
    if( $.inArray( selected_location_type_id, senior_home_location_types ) != -1 ){
      $(".section-requires-location-type-senior-home").show();
    }
    else{
      $(".section-requires-location-type-senior-home").hide();
    }
  }
}
